import Arrow from "@assets/icons/arrow-square-left.svg";
import { useNavigate } from "react-router-dom";
import styles from "./back-button.module.scss";

export const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button onClick={() => navigate(-1)} className={styles.button}>
      <div className={styles.icon}>
        <Arrow />
      </div>
      <span className={styles.text}>Назад</span>
    </button>
  );
};
